import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PagoFacilService {
  constructor(private http: HttpClient) {}

  generarIntencionPago(body: any) {
    return this.http.post<any>(
      environment.endpointPagoFacil,
      body
      // no hace falta headers, Angular agrega Content-Type automáticamente
    );
  }
}